import { useMemo } from 'react';
import MarkdownIt from 'markdown-it';
import { sanitizeHtml } from '@fyos/components';

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true,
  breaks: true,
});

interface MarkdownContentProps {
  content: string;
  className?: string;
}

function isMarkdown(text: string): boolean {
  if (!text || text.trimStart().startsWith('<')) return false;
  return /(?:^|\n)#{1,6}\s|\*\*[^*]+\*\*|__[^_]+__|\*[^*]+\*|_[^_]+_|^\s*[-*+]\s|^\s*\d+\.\s|^>\s|`[^`]+`|\[.+\]\(.+\)|^---$/m.test(text);
}

export default function MarkdownContent({ content, className = '' }: MarkdownContentProps) {
  const html = useMemo(() => {
    if (!content) return '';
    if (isMarkdown(content)) {
      return md.render(content);
    }
    return content;
  }, [content]);

  if (!html) return null;

  return (
    <div
      className={`${className} [&_table]:border-collapse [&_table]:w-full [&_table]:my-3 [&_th]:border [&_th]:border-gray-300 [&_th]:dark:border-gray-600 [&_th]:bg-gray-50 [&_th]:dark:bg-gray-700/50 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:text-xs [&_th]:font-semibold [&_th]:text-gray-700 [&_th]:dark:text-gray-300 [&_td]:border [&_td]:border-gray-300 [&_td]:dark:border-gray-600 [&_td]:px-3 [&_td]:py-2 [&_td]:text-sm`}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
}
